The identifier for the `HiringOrganization` to set disabled features for.
